import { render } from "./DiscountOverview.vue?vue&type=template&id=3b31858e&scoped=true"
import script from "./DiscountOverview.vue?vue&type=script&lang=js"
export * from "./DiscountOverview.vue?vue&type=script&lang=js"

import "./DiscountOverview.vue?vue&type=style&index=0&id=3b31858e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\divindenduitkering_toets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b31858e"]])

export default __exports__